module.exports = __webpack_public_path__ + "img/art2-img5.250f6e5c.jpeg";